import { ApiError } from '@counsel-project/client-utils'

export const getErrorMessage = (error: unknown, defaultMessage = 'An error occurred'): string => {
  return (error as ApiError)?.msg || (error as Error)?.message || defaultMessage
}
